<template>
  <div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t("search_zh")
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t("btnTip.reset")
        }}</el-button>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <el-button type="primary" @click="handleClick('add')">{{
          $t("btnTip.add")
        }}</el-button>
        <el-button type="primary" @click="outExe">{{ $t("outExe") }}</el-button>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <template v-slot:auth="slotProps">
          <div>
            <el-tag :type="authTag(slotProps.callback.row.auth)">{{
              auth(slotProps.callback.row.auth)
            }}</el-tag>
          </div>
        </template>
        <template v-slot:active="slotProps">
          <div>
            <el-tag :type="activeTag(slotProps.callback.row.active)">{{
              active(slotProps.callback.row.active)
            }}</el-tag>
          </div>
        </template>
        <template v-slot:operation="slotProps">
           <el-tooltip
           v-if="slotProps.callback.row.login_count === 5 && userAuth === 1"
            class="item"
            effect="dark"
            content="해제"
            placement="top"
          >
            <el-button
              @click="handleClick('unLock', slotProps.callback.row)"
              type="success"
              size="mini"
              >해제</el-button
            >
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').edit"
            placement="top"
          >
            <el-button
              @click="handleClick('change', slotProps.callback.row)"
              type="primary"
              size="mini"
              >{{ $t("btnTip").edit }}</el-button
            >
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="
              slotProps.callback.row.active === 0
                ? $t('accountManagement').active1
                : $t('accountManagement').active0
            "
            placement="top"
          >
            <el-button
              @click="handleClick('active', slotProps.callback.row)"
              :type="
                slotProps.callback.row.active === 0 ? 'success' : 'warning'
              "
              size="mini"
              >{{
                slotProps.callback.row.active === 0
                  ? $t("accountManagement").active1
                  : $t("accountManagement").active0
              }}</el-button
            >
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').resetPW"
            placement="top"
          >
            <el-button
              @click="handleClick('edit', slotProps.callback.row)"
              type="info"
              size="mini"
              >{{ $t("btnTip").resetPW }}</el-button
            >
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').delete"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              @click="del(slotProps.callback.row.id)"
              >{{ $t("btnTip").delete }}</el-button
            >
          </el-tooltip>
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="500px">
      <form-page
        :ref-obj.sync="formInfo.ref"
        :data="formInfo.data"
        :field-list="formInfo.fieldList"
        :rules="formInfo.rules"
        :label-width="formInfo.labelWidth"
        :list-type-info="listTypeInfo"
        :disabled="formInfo.disabled"
      >
      </form-page>
      <span slot="footer" class="dialog-footer">
        <el-button @click="done('managerForm')" type="primary" class="ml30">{{
          buttonText
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mixin_list } from "@/mixins";
import page from "@/components/page";
import myTable from "@/components/table";
import FormPage from "@/components/FormPage";
import { adminList, adminCreate, adminChange, adminDelete } from "@/api/api";
const formInfoData = {
  username: "",
  password: "",
  menu: [],
  can_manage_sleep:false
};
export default {
  name: "accountManagement",
  mixins: [mixin_list(adminList)],
  components: {
    myTable,
    FormPage,
    page,
  },
  data() {
    return {
      filter: {
        search: "",
      },
      
      columns: [
        {
          label: "ID",
          sortable: true,
          prop: "id",
          width: 80,
        },
        {
          label: this.$t("accountManagement.create_time"),
          sortable: true,
          prop: "create_time",
        },
        {
          label: this.$t("accountManagement.username"),
          sortable: true,
          prop: "username",
        },
        {
          label: this.$t("accountManagement.auth"),
          sortable: true,
          slot: "auth",
          prop: "auth",
        },
        {
          label: this.$t("accountManagement.active"),
          sortable: true,
          slot: "active",
          prop: "active",
        },
        {
          label: this.$t("operation"),
          prop: "",
          width: 420,
          slot: "operation",
        },
      ],
      formInfo: {
        ref: null,
        disabled: false,
        data: formInfoData,
        fieldList: [
          {
            label: this.$t("accountManagement").username,
            value: "username",
            width: "260",
            type: "input",
            className: "el-form-block",
            required: true,
            hidden: false,
          },
          {
            label: this.$t("accountManagement").password,
            value: "password",
            type: "input",
            width: "260",
            className: "el-form-block",
            required: true,
            hidden: false,
          },
          {
            label: this.$t("accountManagement").auth,
            value: "auth",
            type: "select",
            list: "authList",
            width: "260",
            className: "el-form-block",
            required: true,
            hidden: false,
          },
          {
            label: '',
            value: "can_manage_sleep",
            type: "checkBox",
            width: "260",
            className: "el-form-block",
            required: false,
            hidden: false,
          },
        ],
        rules: {},
        labelWidth: "120px",
      },
      listTypeInfo: {
        authList:[
          {
            label:this.$t("accountManagement").auth1,
            value:1
          },
          {
            label:this.$t("accountManagement").auth2,
            value:2
          },
          {
            label:this.$t("accountManagement").auth3,
            value:3
          },
          {
            label:this.$t("accountManagement").auth4,
            value:4
          }
        ]
      },
      dialogFormVisible: false,
      which: "",
    };
  },
  computed: {
    title() {
      switch (this.which) {
        case "add":
          return this.$t("btnTip").add;
        case "edit":
          return this.$t("btnTip").edit;
        case "change":
          return this.$t("btnTip").edit;
      }
    },
    buttonText() {
      switch (this.which) {
        case "add":
          return this.$t("btnTip").add;
        case "edit":
          return this.$t("btnTip").submit;
        case "change":
          return this.$t("btnTip").submit;
      }
    },
    userAuth(){
      return this.$store.state.adminUser.auth
    }
  },
  methods: {
    active(active) {
      switch (active) {
        case 0:
          return this.$t("accountManagement").active0;
        case 1:
          return this.$t("accountManagement").active1;
      }
    },
    activeTag(active) {
      switch (active) {
        case 0:
          return "danger";
        case 1:
          return "success";
      }
    },
    auth(auth) {
      switch (auth) {
        case 1:
          return this.$t("accountManagement").auth1;
        case 2:
          return this.$t("accountManagement").auth2;
        case 3:
          return this.$t("accountManagement").auth3;
        case 4:
          return this.$t("accountManagement").auth4;
          
      }
    },
    authTag(auth) {
      switch (auth) {
        case 0:
          return "success";
        case 1:
          return "";
      }
    },
    async handleClick(type, data) {
      switch (type) {
        case "add":
          this.formInfo.data = formInfoData;
          this.formInfo.fieldList[0].hidden = false;
          this.formInfo.fieldList[0].required = true;
          this.formInfo.fieldList[1].hidden = false;
          this.formInfo.fieldList[1].required = true;
          this.formInfo.fieldList[2].hidden = false;
          this.formInfo.fieldList[2].required = true;
          this.formInfo.fieldList[3].hidden = false;
          this.formInfo.fieldList[3].required = false;
          this.initRules();
          this.formInfo.disabled = type !== "check" ? false : true;
          this.dialogFormVisible = true;
          this.which = type;
          break;
        case "active":
          await adminChange({ id: data.id, active: data.active === 0 ? 1 : 0 });
          this.get_list();
          break;
        case "edit":
          this.formInfo.data = {
            id: data.id,
            password: "",
          };
          this.formInfo.fieldList[0].hidden = true;
          this.formInfo.fieldList[0].required = false;
          this.formInfo.fieldList[1].hidden = false;
          this.formInfo.fieldList[1].required = true;
          this.formInfo.fieldList[2].hidden = true;
          this.formInfo.fieldList[2].required = false;
          this.formInfo.fieldList[3].hidden = true;
          this.formInfo.fieldList[3].required = false;
          this.initRules();
          this.formInfo.disabled = type !== "check" ? false : true;
          this.dialogFormVisible = true;
          this.which = type;
          break;
        case "change":
          this.formInfo.data = {
            ...data,
            can_manage_sleep:data.can_manage_sleep ? true : false
          };
          this.formInfo.fieldList[0].hidden = false;
          this.formInfo.fieldList[0].required = true;
          this.formInfo.fieldList[1].hidden = true;
          this.formInfo.fieldList[1].required = false;
          this.formInfo.fieldList[2].hidden = false;
          this.formInfo.fieldList[2].required = true;
          this.formInfo.fieldList[3].hidden = false;
          this.formInfo.fieldList[3].required = false;
          this.initRules();
          this.formInfo.disabled = type !== "check" ? false : true;
          this.dialogFormVisible = true;
          this.which = type;
          break;
        case "unLock":
          await adminChange({ id: data.id, login_count: 0 });
          this.get_list();
          break;
      }
    },
    done() {
      switch (this.which) {
        case "add":
          this.formInfo.ref.validate(async (valid) => {
            if (valid) {
              await adminCreate({...this.formInfo.data,can_manage_sleep:this.formInfo.data.can_manage_sleep ? 1 : 0});
              this.get_list();
            }
          });
          break;
        case "edit":
          this.formInfo.ref.validate(async (valid) => {
            if (valid) {
              await adminChange({...this.formInfo.data,can_manage_sleep:this.formInfo.data.can_manage_sleep ? 1 : 0});
              this.get_list();
            }
          });
          break;
        case "change":
          this.formInfo.ref.validate(async (valid) => {
            if (valid) {
              await adminChange({...this.formInfo.data,can_manage_sleep:this.formInfo.data.can_manage_sleep ? 1 : 0});
              this.get_list();
            }
          });
          break;
      }
      this.dialogFormVisible = false;
    },
    async del(id) {
      this.$confirm(this.$t('accountManagement').sureDeleteAccount, this.$t('tips'), {
        confirmButtonText: this.$t('btnTips').submit,
        cancelButtonText: this.$t('btnTips').cancel,
        type: 'warning'
      }).then(async () => {
        let res = await adminDelete(id)
        this.get_list()
      }).catch({
      })
    },
  },
};
</script>